import React from "react";
import Button from "../inputs/Button";
import Modal from "../shared/Modal";

const DocumentPreviewModal = ({ isOpen, onClose, document }) => {
  if (!document) return null;

  const footer = (
    <div className="flex justify-end space-x-3">
      <Button variant="outline" onClick={onClose}>
        Close
      </Button>
      <Button variant="primary">Download Document</Button>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={document.name}
      size="lg"
      footer={footer}
    >
      <div className="mb-4">
        <p className="text-sm text-gray-500">
          {document.type} • {document.size} • Uploaded {document.uploadDate}
        </p>
      </div>

      <div className="border border-gray-200 rounded-lg p-8 bg-gray-50 min-h-[400px]">
        <div className="text-center text-gray-500">
          <svg
            className="w-16 h-16 mx-auto mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          <p className="text-lg font-medium mb-2">Document Preview</p>
          <p className="text-sm">This is a mock preview of the document.</p>
          {document.description && (
            <p className="text-sm mt-2">{document.description}</p>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default DocumentPreviewModal;
